import { memo } from "react";
import {
  Box,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { useFormContext } from "@4uhub/lib4uhub";
import { useWatch } from "react-hook-form";
import { TWhatsappTemplateForm } from "./whatsappTemplateSchema";
import { useTranslation } from "react-i18next";
import { Information } from "../../../components/Information/Information";
import { IFileFixedRadioProps } from "./models";
import { useTemplateWhats } from "../../../store/contexts/TemplateWhatsContext";

const translationPath = "chatBot.page.templates.whatsapp_template.";

export const FileFixedRadio = memo(({ id }: IFileFixedRadioProps) => {
  const { t } = useTranslation();

  const { setValue, control, formState } =
    useFormContext<TWhatsappTemplateForm>();

  const { software } = useTemplateWhats();

  const fileFixedError = !!formState?.errors?.fileFixed;

  const fileFixed = useWatch({
    control,
    name: "fileFixed",
  });

  const selectedId = typeof fileFixed !== "boolean" ? null : fileFixed ? 2 : 1;

  const radioOptions = [
    {
      id: 1,
      ...(software === "ChatBot"
        ? {
            label: t(translationPath + "send_selected_file"),
            info: t(translationPath + "send_selected_file_info"),
          }
        : {
            label: t(translationPath + "send_contact_related_file"),
            info: t(translationPath + "send_contact_related_file_info"),
          }),
    },
    {
      id: 2,
      label: t(translationPath + "send_template_related_file"),
      info: t(translationPath + "send_template_related_file_info"),
    },
  ];

  const handleChange = (id: number) => {
    const value = id === 1 ? false : true;
    setValue("fileFixed", value);
  };

  return (
    <Grid item xs={12}>
      <Typography variant="subtitle2" fontWeight="bold">
        {t(translationPath + "file_sending_mode")}
      </Typography>

      <RadioGroup>
        {radioOptions.map((opt) => (
          <Box key={opt.id} sx={{ display: "flex" }}>
            <FormControlLabel
              label={opt.label}
              sx={{ width: "fit-content", mr: 1 }}
              disabled={!!id}
              control={
                <Radio
                  checked={selectedId === opt.id}
                  onChange={() => handleChange(opt.id)}
                />
              }
            />

            <Information title={opt.info} iconSize="small" iconColor="action" />
          </Box>
        ))}
      </RadioGroup>

      {fileFixedError && (
        <Grid item xs={12} sm={12}>
          <Typography color="error" variant="body2">
            {t(translationPath + "errors.file_fixed")}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
});
